export default __webpack_public_path__ + "media/images/celeste_bookmark-ac3d97434ea2a84c37b28b01e3323705.png";